import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => ({
  container: {
    padding: '0',
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '400px',
    height: '40px',
    padding: '8px 16px',
    background: 'linear-gradient(89.96deg, #F7F7F7 64.43%, rgba(196, 196, 196, 0) 106.93%)',
    color: '#0096D6',
    fontSize: '16px',
    fontWeight: '400',
    lineHeight: '24px',
    letterSpacing: '0.15px',
    [theme.breakpoints.down('sm')]: {
      width: '300px',
      padding: '2px 12px',
      fontSize: '14px',
    },
  },
  content: {
    padding: '0 24px 20px 24px',
    [theme.breakpoints.down('sm')]: {
      padding: '16px',
      paddingBottom: '8px',
    },
  },
  contentText: {
    paddingTop: '20px',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '16px',
    },
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '20px',
    paddingRight: '20px',
    [theme.breakpoints.down('sm')]: {
      paddingRight: '8px',
      gap: '15px',
    },
  },
  primaryButton: {
    padding: '4px 10px',
    width: '100px',
    height: '32px',
    color: 'rgba(255, 255, 255, 1)',
    fontSize: '14px',
    fontWeight: '400',
    letterSpacing: '0.4px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      padding: '2px 6px',
      width: '70px',
      height: '26px',
    },
  },
  secondaryButton: {
    padding: '4px 10px',
    width: '100px',
    height: '32px',
    color: '#0096D6',
    fontSize: '14px',
    fontWeight: '400',
    letterSpacing: '0.4px',
    border: '0.75px solid #80CBEB',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      padding: '2px 6px',
      width: '70px',
      height: '26px',
    },
  },
  iconButton: {
    position: 'absolute',
    right: 15,
    padding: '3px',
  },
}))
